import { Grid } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { WsButton, WsDataTable } from 'wisestep-base';

import { allSubmissionTableData } from '../../features/submissions/submissionListing/helper/shareCandidateProfileEmailHelper';

interface IDefaultSubmissionTemplateCustomisationTable {
  onSelectValues: (selectedValues: Record<string, unknown>[]) => void;
  defaultSelectedValues?: Record<string, unknown>[];
  refresh?: boolean;
  type?: string;
}

const DefaultSubmissionTemplateCustomisationTable = ({
  onSelectValues,
  defaultSelectedValues = [],
  type,
}: IDefaultSubmissionTemplateCustomisationTable) => {
  const [selectedIndices, setSelectedIndices] = useState<number[]>([]);
  const indices: number[] = useMemo(() => [], []);

  const [submissionFormSettingsData] = useState<Record<string, unknown>[]>(allSubmissionTableData);

  const columns = [
    {
      Header: 'Select Columns for table',
      accessor: 'parameter',
    },
  ];

  useEffect(() => {
    const getIndices = () => {
      if (defaultSelectedValues && submissionFormSettingsData) {
        defaultSelectedValues.forEach((elem1) => {
          submissionFormSettingsData.forEach((elem2, index2) => {
            if (elem1.value == elem2.value && elem1.parameter == elem2.parameter) {
              indices.push(index2);
            }
          });
        });
      }
    };
    getIndices();
  }, [defaultSelectedValues, indices, submissionFormSettingsData]);

  const onSelectRow = (indices: number[]) => setSelectedIndices(indices);

  const onApply = () => {
    const selectedValues = submissionFormSettingsData
      ? selectedIndices.map((index) => submissionFormSettingsData[index])
      : [];
    onSelectValues(selectedValues);
  };

  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          overflow: 'auto',
          maxHeight: type == 'template' ? '63vh' : '78vh',
        }}
      >
        <WsDataTable
          columns={columns}
          data={submissionFormSettingsData}
          totalDataItems={submissionFormSettingsData?.length}
          selectable={true}
          preSelectedRows={indices}
          pageable={false}
          getSelectedRows={onSelectRow}
        />
      </Grid>
      <Grid item xs={12} pr={2} display="flex" justifyContent="flex-end" alignItems="center">
        <WsButton onClick={onApply}>Apply</WsButton>
      </Grid>
    </>
  );
};

export default DefaultSubmissionTemplateCustomisationTable;
